// ロボ非番判定
const isOffDuty = function (robo, todayIsHoliday) {
  // 祝日判定
  const working_hours = robo.working_hours
  if (working_hours["is_public_holiday"] === true && todayIsHoliday === true) {
    // 非稼働日
    return true
  }

  // 曜日判定
  const jstNow = new Date(Date.now() + ((new Date().getTimezoneOffset() + (9 * 60)) * 60 * 1000));
  let weekDay = -1
  if (jstNow.getDay() == 0) {
      weekDay = 6
  } else {
      weekDay = jstNow.getDay() - 1
  }

  if (working_hours["holiday_list"].includes(weekDay)) {
    // 非稼働曜日
    return true
  }

  // 時間判定
  const roboWorkStart = new Date(jstNow.getFullYear(), jstNow.getMonth(), jstNow.getDate(), working_hours["work_time_start"].substr(0, 2), working_hours["work_time_start"].substr(3));
  const roboWorkEnd = new Date(jstNow.getFullYear(), jstNow.getMonth(), jstNow.getDate(), working_hours["work_time_end"].substr(0, 2), working_hours["work_time_end"].substr(3));
  if (working_hours["is_all_day"] || (roboWorkStart <= jstNow && jstNow <= roboWorkEnd)) {
    // 稼働時間内
    return false
  }

  // 稼働時間外
  return true
}

// ロボ稼働日メッセージ
const getWorkDayMessage = function (robo) {
  const working_hours = robo.working_hours
  // 稼働日メッセージ
  let workDays = []
  if (working_hours["holiday_list"].includes(0) === false) {
    // 月曜日
    workDays.push('月')
  }
  if (working_hours["holiday_list"].includes(1) === false) {
    // 火曜日
    workDays.push('火')
  }
  if (working_hours["holiday_list"].includes(2) === false) {
    // 水曜日
    workDays.push('水')
  }
  if (working_hours["holiday_list"].includes(3) === false) {
    // 木曜日
    workDays.push('木')
  }
  if (working_hours["holiday_list"].includes(4) === false) {
    // 金曜日
    workDays.push('金')
  }
  if (working_hours["holiday_list"].includes(5) === false) {
    // 土曜日
    workDays.push('土')
  }
  if (working_hours["holiday_list"].includes(6) === false) {
    // 日曜日
    workDays.push('日')
  }
  let workDayMessage = ''
  if (workDays.length === 7 && working_hours["is_public_holiday"] == false) {
    // 休みなし
    workDayMessage = '稼働日：年中無休'
  } else if (workDays.length === 7 && working_hours["is_public_holiday"] == true) {
    // 祝日のみ休み
    workDayMessage = '稼働日：年中無休(祝日を除く)'
  } else if (workDays.length !== 7 && working_hours["is_public_holiday"] == true) {
    // 指定曜日と祝日が休み
    workDayMessage = '稼働日：祝日を除く、' + workDays.join('、')
  } else if (workDays.length !== 7 && working_hours["is_public_holiday"] == false){
    // 指定曜日のみ休み
    workDayMessage = '稼働日：' + workDays.join('、')
  } else {
    // 稼働日無し
    workDayMessage = 'ただいま稼働日がありません'
  }
  return workDayMessage
}

// ロボ稼働時間メッセージ
const getWorkTimeMessage = function (robo) {
  const working_hours = robo.working_hours
  let workTimeMessage = ''
  if (working_hours["holiday_list"].length < 7) {
    // 勤務時間メッセージ
    workTimeMessage = '稼働時間：' + working_hours["work_time_start"] + '　～　' + working_hours["work_time_end"]
  }

  return workTimeMessage
}

export {
  isOffDuty,
  getWorkDayMessage,
  getWorkTimeMessage,
}



// WEBPACK FOOTER //
// ./src/functions/robo/roboOffDuty.js